

















































































































import { Component, Prop, Vue, Watch, Mixins } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import anime from "animejs";
import BackgroundLines from "./BackgroundLines.vue";
import constants from "../store/constants";
import Swal from "sweetalert2";

@Component({
  components: {
    BackgroundLines
  }
})
export default class PanoramaWindow extends Vue {
  @State(state => state.app.panoramasWindowOpened)
  panoramasWindowOpened!: boolean;

  contentVisible = false;
  active = false;
  path = "/common/"; // "http://test.local/"

  $refs!: {
    root: HTMLElement;
    wrapper1: HTMLElement;
    wrapper2: HTMLElement;
    whiteLine: HTMLElement;
  };


  @Watch("panoramasWindowOpened")
  stateChange(newValue: boolean, oldValue: boolean) {
    if (newValue) this.openWindow();
    else {
      this.closeWindow();
    }
  }


  openWindow() {
    (anime as any).set(this.$refs.root, {
      width: 0 + "px"
    });
    (anime as any).set(this.$refs.root, {
      height: 1 + "px"
    });
    this.active = true;
    this.contentVisible = true;
    setTimeout(() => {
      (anime as any).set(this.$refs.whiteLine, { opacity: 1 });
      let tl = anime.timeline({ autoplay: true });

      tl.complete = () => {
        this.$refs.root.style.width = `100%`;
        this.$refs.root.style.height = `100vh`;
      }

      tl.add({
        targets: this.$refs.root,
        width: [0, this.$browser.width],
        duration: 680,
        easing: "easeOutQuad"
      });
      tl.add(
        {
          targets: this.$refs.whiteLine,
          opacity: [1, 0],
          duration: 700,
          easing: "easeOutQuad"
        },
        620
      );
      tl.add(
        {
          targets: this.$refs.root,
          height: [1, this.$browser.height],
          duration: 500,
          easing: "easeOutQuad"
        },
        580
      );
      tl.add(
        {
          targets: this.$refs.wrapper1,
          opacity: [0, 1],
          duration: 500,
          easing: "easeOutQuad"
        },
        500
      );
    }, 50);

    setTimeout(() => {
      let pannellumLoadingWait = setInterval(() => {
        if ((window as any).pannellum) {
          clearInterval(pannellumLoadingWait);
          this.activatePanoramasViewer();
        } else {
          console.log("Pannellum not loaded yet");
        }
      }, 100);
    }, 1000);
  }


  closeWindow() {
    this.active = false;
    (anime as any).set(this.$refs.root, {
      width: this.$browser.width + "px"
    });
    (anime as any).set(this.$refs.root, {
      height: this.$browser.height + "px"
    });
    let tl = anime.timeline({ autoplay: true });

    tl.add(
      {
        targets: this.$refs.wrapper1,
        opacity: [1, 0],
        duration: 500,
        easing: "easeOutQuad"
      },
      0
    );
    tl.add(
      {
        targets: this.$refs.whiteLine,
        opacity: [0, 1],
        duration: 700,
        easing: "easeOutQuad"
      },
      0
    );
    tl.add(
      {
        targets: this.$refs.root,
        height: [this.$browser.height, 1],
        duration: 500,
        easing: "easeOutQuad"
      },
      200
    );
    tl.add(
      {
        targets: this.$refs.root,
        width: [this.$browser.width, 0],
        duration: 680,
        easing: "easeOutQuad"
      },
      700
    );
    setTimeout(() => {
      document.querySelector<HTMLElement>("#panorama")!.innerHTML = "";
      if (this.viewer) {
        this.viewer.destroy();
      }
      if (!this.active) this.contentVisible = false;
    }, 2000);
  }


  mounted() {
    window.addEventListener("keydown", (e: KeyboardEvent) => {
      if (this.panoramasWindowOpened && e.keyCode == 27) {
        this.close();
      }
    });

    let interval: any = null;
    let zoomPlus = this.$refs.root.querySelector<HTMLElement>("#panorama-zoom-plus")!;
    let zoomMinus = this.$refs.root.querySelector<HTMLElement>("#panorama-zoom-minus")!;
    let picker = this.$refs.root.querySelector<HTMLInputElement>("#panorama-range-picker")!;
    let imageMenu = this.$refs.root.querySelector<HTMLInputElement>(".panorama-image-menu")!;
    let wrappers = this.$refs.root.querySelectorAll<HTMLInputElement>(".wrapper")!;

    wrappers.forEach((wrapper) => {
      wrapper.addEventListener("mouseenter", () => {
        (function () {
          imageMenu.style.width = "450px";
        })();
      });

      wrapper.addEventListener("mouseleave", () => {
        (function () {
          imageMenu.style.width = "unset";
        })();
      });
    });

    zoomPlus.addEventListener("mousedown", () => {
      interval = setInterval(() => {
        if (parseInt(picker.value) > 50) {
          this.iterateHov(true);
        }
      }, 50);
    });

    zoomMinus.addEventListener("mousedown", () => {
      interval = setInterval(() => {
        if (parseInt(picker.value) < 120) {
          this.iterateHov(false);
        }
      }, 50);
    });

    window.addEventListener("mouseup", () => {
      clearInterval(interval);
    });
  }


  close() {
    this.$store.dispatch(constants.hidePanoramas);
  }

  /***************************/
  /***************************/
  /***************************/

  titles: any = {
    dubrov: "Ресторан-курорт 'Дубровский'",
    fromTop: "Участок, вид сверху",
    fromSide: "Участок, вид сбоку",
    bricks: "Кладка цоколя кирпичем",
    tent: "Подготовка к заливке бетона",
    basement: "Монтаж перекрытий",
    firstFloor: "Кладка кирпича",
    secondFloor: "Монтаж перекрытий 2 этаж",
    winter: "Зимняя панорама",
    building: "Участок, вид сверху",
    bricksSecondFloor: "Кладка кирпича, 2 этаж"
  };

  hotSpotTitles: any = {
    busStop: "Остановка общественного транспорта",
    kindergarten: "Детский садик",
    ocheretLake: 'Озеро "Очерет"',
    pineForest: "Сосновый лес",
    school: "Школа №96",
    oakForest: "Дубовый лес",
    shevchenkoStreet: "Улица Шевченко 3.5 км",
    kharkovRiver: 'Река "Харьков"',
    posadStore: 'Круглосуточный магазин "Посад"'
  };

  viewer: any = null;
  isRotating: any = true;
  timeOut: any = null;

  buildingsVisited: any = {
    fromTop: true,
    fromSide: false,
    dubrov: false,
    bricksSecondFloorFromTop: true,
    bricksSecondFloorFromSide: false
  };


  iterateHov(val: any) {
    let picker = this.$refs.root.querySelector<HTMLInputElement>("#panorama-range-picker")!;
    var currentValue;
    if (val) currentValue = parseInt(picker.value) - 5;
    else currentValue = parseInt(picker.value) + 5;
    picker.value = currentValue.toString();
    this.changeHov();
  }


  changeHov() {
    let picker = this.$refs.root.querySelector<HTMLInputElement>("#panorama-range-picker")!;
    var z = parseInt(picker.value);
    this.viewer.setHfov(z, 0)
  }


  reloadPanorama(panoramaTitle: any) {
    this.$refs.root.querySelector<HTMLElement>("#panorama")!.innerHTML = "";
    if (this.viewer) this.viewer.destroy();
    this.showTitle(this.titles[panoramaTitle]);
    this.loadPanorama(panoramaTitle);
    this.markVisitedSpotBuildings(this.viewer);
    this.onHfovChangeEvent(this.viewer);
  }


  hotspot(hotSpotDiv: any, args: any) {
    hotSpotDiv.classList.add("custom-tooltip");
    var span = document.createElement("span");
    span.innerHTML =
      args.title +
      "<img src='" +
      args.img +
      "' style='height:100px;width:100%;'>";
    this.configTooltip(span, hotSpotDiv);
  }


  showTitle(title: any) {
    this.$refs.root.querySelector<HTMLElement>(".panorama-title")!.innerHTML = title;
    this.$refs.root.querySelector<HTMLElement>(".panorama-title")!.style.visibility = "visible";
    window.clearTimeout(this.timeOut);
    this.timeOut = window.setTimeout(() => {
      this.$refs.root.querySelector<HTMLElement>(".panorama-title")!.style.visibility = "hidden";
    }, 4000);
  }


  hotspotSimple(hotSpotDiv: any, args: any) {
    hotSpotDiv.classList.add("custom-tooltip");
    var span = document.createElement("span");
    span.innerHTML =
      args.title +
      "<img src='" +
      args.img +
      "' style='height:100px;width:100%;'>";
    this.configTooltip(span, hotSpotDiv);
  }


  configTooltip(span: any, hotSpotDiv: any) {
    hotSpotDiv.appendChild(span);
    span.style.width = span.scrollWidth - 20 + "px";
    span.style.marginLeft =
      -(span.scrollWidth - hotSpotDiv.offsetWidth) / 2 + "px";
    span.style.marginTop = -span.scrollHeight - 12 + "px";
  }


  showTip(number: number, text: string) {
    let element = this.$refs.root.querySelectorAll<HTMLElement>(".panorama-image-menu-inner .wrapper")[number];
    let textBlock = document.createElement("div");
    textBlock.innerText = text;
    textBlock.classList.add("tooltip");
    element.insertBefore(textBlock, element.firstChild);
  }


  hideTips() {
    let tooltip = this.$refs.root.querySelector<HTMLElement>(".tooltip");
    if (tooltip !== null) {
      tooltip.parentElement!.removeChild(tooltip);
    }
  }


  rotate() {
    let button = this.$refs.root.querySelector("#auto-rotate-button")!;
    if (button.getAttribute("rotating") == "true") {
      this.viewer.stopAutoRotate()
      this.isRotating = false;
      button.setAttribute("rotating", "false");
    }
    else {
      this.viewer.startAutoRotate();
      this.isRotating = true;
      button.setAttribute("rotating", "true");
    }
  }


  onHfovChangeEvent(viewer: any) {
    viewer.on("zoomchange", (args: any) => {
      this.$refs.root.querySelector<HTMLInputElement>("#panorama-range-picker")!.value = args;
    });
  }


  markVisitedSpotBuildings(viewer: any) {
    viewer.on("scenechange", (args: string) => {
      this.buildingsVisited[args] = true;
      this.markVisitedHotSpots(viewer.getConfig().hotSpots);
      this.showTitle(this.titles[args]);
    });
  }


  markVisitedHotSpots(currentConfig: any) {
    for (var i = 0; i < currentConfig.length; i++) {
      if (this.buildingsVisited[currentConfig[i].sceneId] == true) {
        currentConfig[i].cssClass = "custom-visited-hotspot";
      }
    }
  }


  getBuildingClassByVisitedMark(name: any, array: any) {
    return array[name] == true ? "custom-visited-hotspot" : "custom-hotspot";
  }


  loadPanorama(panoramaTitle: any) {
    switch (panoramaTitle) {
      case "winter":
        this.loadPanoramaWinter();
        break;
      case "secondFloor":
        this.loadPanoramaSecondFloorFloor();
        break;
      case "firstFloor":
        this.loadPanoramaFirstFloor();
        break;
      case "basement":
        this.loadPanoramaBasement();
        break;
      case "bricks":
        this.loadPanoramaBricks();
        break;
      case "building":
        this.loadPanoramaBuildings();
        break;
      case "tent":
        this.loadPanoramaTent();
        break;
      case "bricksSecondFloor":
        this.loadPanoramaBricksSecondFloor();
        break;
    }
  }


  loadPanoramaBricksSecondFloor() {
    this.viewer = (window as any).pannellum.viewer("panorama", {
      default: {
        autoLoad: true,
        firstScene: "bricksSecondFloorFromTop",
        sceneFadeDuration: 1000
      },
      dynamicUpdate: true,
      showZoomCtrl: false,
      scenes: {
        bricksSecondFloorFromTop: {
          autoRotate: this.isRotating,
          hfov: 120.0,
          type: "multires",
          multiRes: {
            path:
              this.path + "/panorams/8.SecondFloorBricks/outputfromTop/%l/%s%y_%x",
            fallbackPath:
              this.path + "/panorams/8.SecondFloorBricks/outputfromTop/fallback/%s",
            extension: "jpg",
            tileResolution: 512,
            maxLevel: 4,
            cubeResolution: 3816
          },
          hotSpots: [
            {
              cssClass: this.getBuildingClassByVisitedMark(
                "bricksSecondFloorFromSide",
                this.buildingsVisited
              ),
              createTooltipFunc: this.hotspot.bind(this),
              createTooltipArgs: {
                title: this.titles.bricksSecondFloor,
                img: this.path + "/panorams/tempLittleImages/FromTopLittle.jpg"
              },
              pitch: -5.63,
              yaw: 71.2,
              type: "scene",
              sceneId: "bricksSecondFloorFromSide"
            }
          ]
        },
        bricksSecondFloorFromSide: {
          autoRotate: this.isRotating,
          hfov: 120.0,
          type: "multires",
          multiRes: {
            path:
              this.path + "/panorams/8.SecondFloorBricks/outputFromSide/%l/%s%y_%x",
            fallbackPath:
              this.path + "/panorams/8.SecondFloorBricks/outputFromSide/fallback/%s",
            extension: "jpg",
            tileResolution: 512,
            maxLevel: 4,
            cubeResolution: 3816
          },
          hotSpots: [
            {
              cssClass: this.getBuildingClassByVisitedMark(
                "bricksSecondFloorFromTop",
                this.buildingsVisited
              ),
              createTooltipFunc: this.hotspot.bind(this),
              createTooltipArgs: {
                title: this.titles.bricksSecondFloor,
                img: this.path + "/panorams/tempLittleImages/FromTopLittle.jpg"
              },
              pitch: 24.6,
              yaw: -77.1,
              type: "scene",
              sceneId: "bricksSecondFloorFromTop"
            }
          ]
        }
      }
    });
  }

  loadPanoramaWinter() {
    this.viewer = (window as any).pannellum.viewer("panorama", {
      default: {
        autoLoad: true,
        firstScene: "winter",
        sceneFadeDuration: 1000
      },

      dynamicUpdate: true,
      showZoomCtrl: false,
      scenes: {
        winter: {
          autoRotate: this.isRotating,
          hfov: 100.0,
          type: "multires",
          multiRes: {
            path: this.path + "/panorams/3.Winter/output/%l/%s%y_%x",
            fallbackPath: this.path + "/panorams/3.Winter/output/fallback/%s",
            extension: "jpg",
            tileResolution: 512,
            maxLevel: 5,
            cubeResolution: 4768
          }
        }
      }
    });
  }

  loadPanoramaSecondFloorFloor() {
    this.viewer = (window as any).pannellum.viewer("panorama", {
      default: {
        autoLoad: true,
        firstScene: "secondFloor",
        sceneFadeDuration: 1000
      },

      dynamicUpdate: true,
      showZoomCtrl: false,
      scenes: {
        secondFloor: {
          autoRotate: this.isRotating,
          hfov: 120.0,
          type: "multires",
          yaw: -80,
          multiRes: {
            path: this.path + "/panorams/7SecondFloor/output/%l/%s%y_%x",
            fallbackPath: this.path + "/panorams/7SecondFloor/output/fallback/%s",
            extension: "jpg",
            tileResolution: 512,
            maxLevel: 4,
            cubeResolution: 3176
          }
        }
      }
    });
  }

  loadPanoramaFirstFloor() {
    this.viewer = (window as any).pannellum.viewer("panorama", {
      default: {
        autoLoad: true,
        firstScene: "firstFloor",
        sceneFadeDuration: 1000
      },

      dynamicUpdate: true,
      showZoomCtrl: false,
      scenes: {
        firstFloor: {
          autoRotate: this.isRotating,
          hfov: 120.0,
          type: "multires",
          multiRes: {
            path: this.path + "/panorams/6.FirstFloorWalls/output/%l/%s%y_%x",
            fallbackPath:
              this.path + "/panorams/6.FirstFloorWalls/output/fallback/%s",
            extension: "jpg",
            tileResolution: 512,
            maxLevel: 5,
            cubeResolution: 4768
          }
        }
      }
    });
  }

  loadPanoramaBasement() {
    this.viewer = (window as any).pannellum.viewer("panorama", {
      default: {
        autoLoad: true,
        firstScene: "basement",
        sceneFadeDuration: 1000
      },

      dynamicUpdate: true,
      showZoomCtrl: false,
      scenes: {
        basement: {
          autoRotate: this.isRotating,
          hfov: 120.0,
          type: "multires",
          multiRes: {
            path: this.path + "/panorams/5.Basement/output/%l/%s%y_%x",
            fallbackPath: this.path + "/panorams/5.Basement/output/fallback/%s",
            extension: "jpg",
            tileResolution: 512,
            maxLevel: 4,
            cubeResolution: 3816
          }
        }
      }
    });
  }

  loadPanoramaTent() {
    this.viewer = (window as any).pannellum.viewer("panorama", {
      default: {
        autoLoad: true,
        firstScene: "tent",
        sceneFadeDuration: 1000
      },

      dynamicUpdate: true,
      showZoomCtrl: false,
      scenes: {
        tent: {
          autoRotate: this.isRotating,
          hfov: 120.0,
          type: "multires",
          multiRes: {
            path: this.path + "/panorams/2.Tent/output/%l/%s%y_%x",
            fallbackPath: this.path + "/panorams/2.Tent/output/fallback/%s",
            extension: "jpg",
            tileResolution: 512,
            maxLevel: 4,
            cubeResolution: 2200
          }
        }
      }
    });
  }

  loadPanoramaBricks() {
    this.viewer = (window as any).pannellum.viewer("panorama", {
      default: {
        autoLoad: true,
        firstScene: "bricks",
        sceneFadeDuration: 1000
      },
      dynamicUpdate: true,
      showZoomCtrl: false,
      scenes: {
        bricks: {
          autoRotate: this.isRotating,
          hfov: 120.0,
          type: "multires",
          multiRes: {
            path: this.path + "/panorams/4.Bricks/output/%l/%s%y_%x",
            fallbackPath: this.path + "/panorams/4.Bricks/output/fallback/%s",
            extension: "jpg",
            tileResolution: 512,
            maxLevel: 5,
            cubeResolution: 4768
          }
        }
      }
    });
  }

  loadPanoramaBuildings() {
    this.viewer = (window as any).pannellum.viewer("panorama", {
      default: {
        autoLoad: true,
        firstScene: "fromTop",
        sceneFadeDuration: 1000
      },
      dynamicUpdate: true,
      showZoomCtrl: false,
      autoRotateInactivityDelay: 5000,
      scenes: {
        fromTop: {
          yaw: -11.007455,
          pitch: -87.51641106,
          hfov: 120.0,
          type: "multires",
          autoRotate: this.isRotating,
          multiRes: {
            path: this.path + "/panorams/1.Buildings/outputFromTop/%l/%s%y_%x",
            fallbackPath:
              this.path + "/panorams/1.Buildings/outputFromTop/fallback/%s",
            extension: "jpg",
            tileResolution: 512,
            maxLevel: 5,
            cubeResolution: 4768
          },
          hotSpots: [
            {
              cssClass: this.getBuildingClassByVisitedMark(
                "fromSide",
                this.buildingsVisited
              ),
              createTooltipFunc: this.hotspot.bind(this),
              createTooltipArgs: {
                title: this.titles.fromSide,
                img: this.path + "/panorams/tempLittleImages/FromSideLittle.jpg"
              },
              pitch: -30.42,
              yaw: -10.3,
              type: "scene",
              sceneId: "fromSide"
            },
            {
              cssClass: this.getBuildingClassByVisitedMark(
                "dubrov",
                this.buildingsVisited
              ),
              createTooltipFunc: this.hotspot.bind(this),
              createTooltipArgs: {
                title: this.titles.dubrov,
                img: this.path + "/panorams/tempLittleImages/DubrovLittle.jpg"
              },
              pitch: 4.1,
              yaw: -338.9,
              targetYaw: 550,
              type: "scene",
              sceneId: "dubrov"
            },
            {
              cssClass: "custom-hotspot-simple",
              createTooltipFunc: this.hotspotSimple.bind(this),
              createTooltipArgs: {
                title: this.hotSpotTitles.oakForest,
                img: this.path + "/simple-hot-spots-images/oak-forest.jpg"
              },
              pitch: -20.1,
              yaw: 205.9
            },
            {
              cssClass: "custom-hotspot-simple",
              createTooltipFunc: this.hotspotSimple.bind(this),
              createTooltipArgs: {
                title: this.hotSpotTitles.pineForest,
                img: this.path + "/simple-hot-spots-images/pine-forest.jpg"
              },
              pitch: -3,
              yaw: 285.9
            },
            {
              cssClass: "custom-hotspot-simple",
              createTooltipFunc: this.hotspotSimple.bind(this),
              createTooltipArgs: {
                title: this.hotSpotTitles.kharkovRiver,
                img: this.path + "/simple-hot-spots-images/kharkov-river.jpg"
              },
              pitch: -10,
              yaw: 331.9
            },
            {
              cssClass: "custom-hotspot-simple",
              createTooltipFunc: this.hotspotSimple.bind(this),
              createTooltipArgs: {
                title: this.hotSpotTitles.ocheretLake,
                img: this.path + "/simple-hot-spots-images/ocheret-lake.jpg"
              },
              pitch: -3.5,
              yaw: 495.9
            }
          ]
        },

        fromSide: {
          hfov: 120.0,
          type: "multires",
          autoRotate: this.isRotating,
          multiRes: {
            path: this.path + "/panorams/1.Buildings/outputFromSide/%l/%s%y_%x",
            fallbackPath:
              this.path + "/panorams/1.Buildings/outputFromSide/fallback/%s",
            extension: "jpg",
            tileResolution: 512,
            maxLevel: 5,
            cubeResolution: 4768
          },
          hotSpots: [
            {
              cssClass: this.getBuildingClassByVisitedMark(
                "fromTop",
                this.buildingsVisited
              ),
              createTooltipFunc: this.hotspot.bind(this),
              createTooltipArgs: {
                title: this.titles.fromTop,
                img: this.path + "/panorams/tempLittleImages/FromTopLittle.jpg"
              },
              pitch: 50.6,
              yaw: 147.1,
              type: "scene",
              sceneId: "fromTop"
            },
            {
              cssClass: this.getBuildingClassByVisitedMark(
                "dubrov",
                this.buildingsVisited
              ),
              createTooltipFunc: this.hotspot.bind(this),
              createTooltipArgs: {
                title: this.titles.dubrov,
                img: this.path + "/panorams/tempLittleImages/DubrovLittle.jpg"
              },
              pitch: 6.1,
              targetYaw: 550,
              yaw: -322.9,
              type: "scene",
              sceneId: "dubrov"
            },
            {
              cssClass: "custom-hotspot-simple",
              createTooltipFunc: this.hotspotSimple.bind(this),
              createTooltipArgs: {
                title: this.hotSpotTitles.oakForest,
                img: this.path + "/simple-hot-spots-images/oak-forest.jpg"
              },
              pitch: -2,
              yaw: 205.9
            },
            {
              cssClass: "custom-hotspot-simple",
              createTooltipFunc: this.hotspotSimple.bind(this),
              createTooltipArgs: {
                title: this.hotSpotTitles.pineForest,
                img: this.path + "/simple-hot-spots-images/pine-forest.jpg"
              },
              pitch: 1,
              yaw: 290.9
            }
          ]
        },
        dubrov: {
          autoRotate: this.isRotating,
          yaw: 115,
          hfov: 120.0,
          type: "multires",
          multiRes: {
            path: this.path + "/panorams/1.Buildings/outputDubrov/%l/%s%y_%x",
            fallbackPath:
              this.path + "/panorams/1.Buildings/outputDubrov/fallback/%s",
            extension: "jpg",
            tileResolution: 512,
            maxLevel: 5,
            cubeResolution: 4768
          },
          hotSpots: [
            {
              cssClass: this.getBuildingClassByVisitedMark(
                "fromTop",
                this.buildingsVisited
              ),
              createTooltipFunc: this.hotspot.bind(this),
              createTooltipArgs: {
                title: this.titles.fromTop,
                img: this.path + "/panorams/tempLittleImages/FromTopLittle.jpg"
              },
              pitch: 10.6,
              yaw: -167.1,
              type: "scene",
              sceneId: "fromTop"
            },
            {
              cssClass: this.getBuildingClassByVisitedMark(
                "fromSide",
                this.buildingsVisited
              ),
              createTooltipFunc: this.hotspot.bind(this),
              createTooltipArgs: {
                title: this.titles.fromSide,
                img: this.path + "/panorams/tempLittleImages/FromSideLittle.jpg"
              },
              pitch: 1.6,
              yaw: -162.1,
              type: "scene",
              sceneId: "fromSide"
            },
            {
              cssClass: "custom-hotspot-simple",
              createTooltipFunc: this.hotspotSimple.bind(this),
              createTooltipArgs: {
                title: this.hotSpotTitles.kharkovRiver,
                img: this.path + "/simple-hot-spots-images/kharkov-river.jpg"
              },
              pitch: -42.1,
              yaw: -110
            },
            {
              cssClass: "custom-hotspot-simple",
              createTooltipFunc: this.hotspotSimple.bind(this),
              createTooltipArgs: {
                title: this.hotSpotTitles.school,
                img: this.path + "/simple-hot-spots-images/school.jpg"
              },
              pitch: -3.5,
              yaw: -3.8
            },
            {
              cssClass: "custom-hotspot-simple",
              createTooltipFunc: this.hotspotSimple.bind(this),
              createTooltipArgs: {
                title: this.hotSpotTitles.posadStore,
                img: this.path + "/simple-hot-spots-images/posad-store.jpg"
              },
              pitch: -5,
              yaw: 5.8
            },
            {
              cssClass: "custom-hotspot-simple",
              createTooltipFunc: this.hotspotSimple.bind(this),
              createTooltipArgs: {
                title: this.hotSpotTitles.kindergarten,
                img: this.path + "/simple-hot-spots-images/kindergarten.jpg"
              },
              pitch: -4,
              yaw: 21.7
            },
            {
              cssClass: "custom-hotspot-simple",
              createTooltipFunc: this.hotspotSimple.bind(this),
              createTooltipArgs: {
                title: this.hotSpotTitles.busStop,
                img: this.path + "/simple-hot-spots-images/bus-stop.png"
              },
              pitch: -5,
              yaw: 42.7
            },
            {
              cssClass: "custom-hotspot-simple",
              createTooltipFunc: this.hotspotSimple.bind(this),
              createTooltipArgs: {
                title: this.hotSpotTitles.shevchenkoStreet,
                img: this.path + "/simple-hot-spots-images/shevchenko-street.png"
              },
              pitch: -3,
              yaw: 52.7
            }
          ]
        }
      }
    });
  }

  activatePanoramasViewer() {
    this.reloadPanorama("building");
  }
}
